<template>
  <div>
    <!-- <app-header>
      <router-link slot="left" to="/" class="logolink">
        <img :src="assetsPath +'static/images/logo.png'" style="display:inline-block; height:2rem;">
      </router-link>
    </app-header> -->
    <div class="app-body">
      <div class="s404-img">
        <img :src="assetsPath + 'static/images/404.jpg'">
      </div>
    </div>
    <!-- <app-footer></app-footer> -->
  </div>
</template>
<script>
import AppHeader from './app-header.vue';
import AppFooter from './app-footer.vue';
import tools from 'jyutils/tools';

export default {
  components: { AppHeader, AppFooter },
  mixins: [tools],
}
</script>
<style lang="less" scoped>
.logolink {
  .flex-center-v();
}
.s404-img{margin:3rem auto; text-align:center;}
.s404-img img{max-width:100%;}
</style>